import { CountryRegionsGridView } from '~/components/system/country-regions';
import { PageContainer } from '~/components/page-container';

export function CountryRegions() {
	return (
		<PageContainer>
			<CountryRegionsGridView />
		</PageContainer>
	);
}
